/**
 * Counts the number of selected filters based on their values.
 *
 * - Arrays count as 1 if they have at least one item.
 * - Objects count as 1 if they have at least one defined, non-undefined value.
 * - Strings and other values count as 1 if they are not undefined, or empty.
 *
 * @param filters An object containing the filters to evaluate.
 * @returns The number of active filters.
 */

export function countSelectedFilters(filters: Record<string, unknown>): number {
  return Object.values(filters).reduce<number>((count, value) => {
    if (Array.isArray(value)) {
      return count + (value.length > 0 ? 1 : 0)
    } else if (typeof value === 'object' && value !== null) {
      return count + (Object.values(value).some((v) => v !== undefined) ? 1 : 0)
    } else if (typeof value === 'boolean') {
      return count + (value ? 1 : 0)
    } else {
      return count + +(value !== undefined && value !== '')
    }
  }, 0)
}
